<template>
  <a
    class="nav-link d-flex align-items-end"
    :href="urlWishList"
    rel="nofollow"
    :aria-label="$translate('Ceres::Template.wishList')"
  >
    <i
      class="fa"
      :class="{'fa-heart fal': !wishListCount, 'fa-heart': wishListCount}"
      aria-hidden="true"
    />
    <span class="badge-right ml-1">{{ wishListCount }}</span>
  </a>
</template>

<script>
export default {
    computed:
            {
                wishListCount () {
                    return this.$store.getters.wishListCount
                },
                urlWishList () {
                    return App.urls.wishList
                }
            }
}
</script>
